import apiSlice from './apiSlice';

const apiSliceWithTag = apiSlice.enhanceEndpoints({ addTagTypes: ['Stats'] });

const apiStatsSlice = apiSliceWithTag.injectEndpoints({
  endpoints: (builder) => ({
    getAnalysisTimeframe: builder.query({
      query: () => ({
        url: `/community/stats/analysis_timeframe/`,
        method: 'GET',
      }),
      providesTags: ['Stats'],
    }),
    getTerms: builder.query({
      query: ({ ordering }) => ({
        url: `/community/stats/terms/`,
        method: 'GET',
        params: {
          ordering,
        },
      }),
      providesTags: ['Stats'],
    }),
    getVisits: builder.query({
      query: ({ eans, ordering, page, psize }) => ({
        url: `/community/stats/visits/`,
        method: 'GET',
        params: {
          eans,
          ordering,
          page,
          psize,
        },
      }),
      providesTags: ['Stats'],
    }),
  }),
});

export const { useGetAnalysisTimeframeQuery, useGetTermsQuery, useGetVisitsQuery } = apiStatsSlice;

export default apiStatsSlice;
